
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-slate-800 via-slate-700 to-slate-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
          <div>
            <div className="flex items-center space-x-3 mb-6">
              <div className="w-12 h-12 bg-white rounded-lg flex items-center justify-center">
                <span className="text-slate-800 font-bold text-xl">재기</span>
              </div>
              <div>
                <div className="text-white font-bold text-xl">재기목형</div>
                <div className="text-gray-400 text-xs">JAEKI WOODMOLD</div>
              </div>
            </div>
            <div className="space-y-2 text-sm">
              <p>
                <span className="text-gray-400">회사명:</span> 주식회사 재기목형
              </p>
              <p>
                <span className="text-gray-400">대표자:</span> 홍재기
              </p>
              <p>
                <span className="text-gray-400">사업자번호:</span> 201-86-41632
              </p>
              <p>
                <span className="text-gray-400">TEL:</span> 02-2263-8248
              </p>
              <p>
                <span className="text-gray-400">FAX:</span> 02-2263-3616
              </p>
              <p>
                <span className="text-gray-400">E-mail:</span>{' '}
                <a href="mailto:jk8248@hanmail.net" className="hover:text-amber-400 transition-colors cursor-pointer">
                  jk8248@hanmail.net
                </a>
              </p>
              <p className="pt-2 text-gray-400">서울특별시 중구 을지로 27가길 22 대륙빌딩(주교동)</p>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-bold text-white mb-4">CS CENTER</h3>
            <div className="space-y-3">
              <a href="tel:02-2263-8248" className="block cursor-pointer">
                <p className="text-3xl font-bold text-amber-400 hover:text-amber-300 transition-colors">02-2263-8248</p>
              </a>
              <p className="text-sm text-gray-400">
                내선번호 안내
              </p>
              <ul className="text-sm text-gray-400 space-y-1">
                <li>• 관리: 1번</li>
                <li>• 도안팀: 0번, 2번, 3번, 4번</li>
              </ul>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-bold text-white mb-4">빠른 링크</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/about" className="hover:text-amber-400 transition-colors">
                  회사소개
                </Link>
              </li>
              <li>
                <Link to="/wood" className="hover:text-amber-400 transition-colors">
                  목형 제품
                </Link>
              </li>
              <li>
                <Link to="/laser" className="hover:text-amber-400 transition-colors">
                  레이저 가공
                </Link>
              </li>
              <li>
                <Link to="/portfolio" className="hover:text-amber-400 transition-colors">
                  포트폴리오
                </Link>
              </li>
              <li>
                <Link to="/quote" className="hover:text-amber-400 transition-colors">
                  견적문의
                </Link>
              </li>
              <li>
                <Link to="/location" className="hover:text-amber-400 transition-colors">
                  오시는길
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-600 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-400">
          <p>COPYRIGHT(C) 2019 주식회사 재기목형. All rights reserved.</p>
          <a
            href="https://readdy.ai/?ref=logo"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-amber-400 transition-colors cursor-pointer"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
